import React, { useState, useEffect } from "react";

import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";
import { Box, Typography } from "@material-ui/core";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import useSettings from "../../hooks/useSettings";
import { getBackendUrl } from "../../config";
import { sanitizeUrl } from "../../utils/sanitize";

const defaultLogoLight = require("../../assets/logo.png");

const useStyles = makeStyles(theme => ({
	backdrop: {
		zIndex: theme.zIndex.drawer + 1,
		color: "#fff",
		flexDirection: "column",
		gap: theme.spacing(3),
	},
	logoContainer: {
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		gap: theme.spacing(2),
	},
	logo: {
		maxWidth: 200,
		maxHeight: 120,
		width: "auto",
		height: "auto",
		filter: "drop-shadow(0 2px 8px rgba(0, 0, 0, 0.3))",
	},
	loadingText: {
		marginTop: theme.spacing(1),
		fontSize: "0.875rem",
		opacity: 0.8,
		textAlign: "center",
	},
	progressContainer: {
		position: "relative",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
	},
}));

const BackdropLoading = () => {
	const classes = useStyles();
	const theme = useTheme();
	const { getPublicSetting } = useSettings();
	
	const [logo, setLogo] = useState(defaultLogoLight);
	const [appName, setAppName] = useState("LiotPro");
	const [primaryColor, setPrimaryColor] = useState("#065183");

	useEffect(() => {
		// Buscar configurações da empresa ID 1
		const fetchCompanySettings = async () => {
			try {
				// Buscar logo da empresa
				const logoFile = await getPublicSetting("appLogoLight", 1);
				if (logoFile && typeof logoFile === 'string') {
					// Sanitizar URL para prevenir XSS
					const logoUrl = getBackendUrl() + "/public/" + logoFile;
					const safeLogo = sanitizeUrl(logoUrl);
					if (safeLogo) {
						setLogo(safeLogo);
					}
				}

				// Buscar nome da aplicação
				const name = await getPublicSetting("appName", 1);
				if (name && typeof name === 'string') {
					// Sanitizar texto (previne XSS via nome)
					setAppName(name.substring(0, 100)); // Limita tamanho
				}

				// Buscar cor primária do modo claro
				const color = await getPublicSetting("primaryColorLight", 1);
				if (color && typeof color === 'string' && /^#[0-9A-F]{6}$/i.test(color)) {
					// Valida que é uma cor hex válida
					setPrimaryColor(color);
				}
			} catch (error) {
				console.log("Erro ao buscar configurações da empresa:", error);
			}
		};

		fetchCompanySettings();
	}, [getPublicSetting]);

	return (
		<Backdrop 
			className={classes.backdrop} 
			open={true}
			style={{ backgroundColor: primaryColor }}
		>
			<Box className={classes.logoContainer}>
				<img 
					src={logo} 
					alt={appName}
					className={classes.logo}
					onError={(e) => {
						// Fallback para logo padrão se houver erro
						e.target.src = defaultLogoLight;
					}}
				/>
				<Typography 
					variant="h6" 
					className={classes.loadingText}
					style={{ color: 'white' }}
				>
					{appName}
				</Typography>
			</Box>
			
			<Box className={classes.progressContainer}>
				<CircularProgress 
					size={60}
					thickness={4}
					style={{ 
						color: 'white',
						filter: 'drop-shadow(0 2px 4px rgba(0, 0, 0, 0.2))'
					}} 
				/>
			</Box>
			
			<Typography 
				variant="body2" 
				className={classes.loadingText}
				style={{ color: 'rgba(255, 255, 255, 0.8)' }}
			>
				Carregando...
			</Typography>
		</Backdrop>
	);
};

export default BackdropLoading;
